function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import React, { createContext, useContext, useReducer } from 'react';
import { PropTypes } from 'prop-types';
import { ADD_PROGRAM, ADD_PROGRAMS, REMOVE_PROGRAM, REPLACE_PROGRAMS, REMOVE_ALL_PROGRAMS } from './constants';
import { uniqueArray } from '../utils/arrayUtils';
var SelectedProgramsProviderContext = /*#__PURE__*/createContext(null);
var useSelectedProgramsContext = function useSelectedProgramsContext() {
  var context = useContext(SelectedProgramsProviderContext);
  if (!context) {
    throw new Error('SelectedProgramsProviderContext must be used with SelectedProgramsProvider');
  }
  return context;
};
var initState = [];
function isAlreadySelected(programsContext, id, service) {
  return programsContext.some(function (prog) {
    return prog.id === id && prog.service === service;
  });
}
function isUnlistedAlreadySelected(programsContext, name, service) {
  return programsContext.some(function (prog) {
    return prog.name === name && prog.service === service;
  });
}
function validateType(payload, expectedType) {
  if (_typeof(payload) !== _typeof(expectedType)) {
    throw new Error("Invalid payload type provided to selectedProgramsReducer - type should be ".concat(_typeof(expectedType)));
  }
}
function selectedProgramsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case ADD_PROGRAM:
      {
        validateType(payload, {});
        var id = payload.id,
          isSensitive = payload.isSensitive,
          name = payload.name,
          providerId = payload.providerId,
          providerLicensed = payload.providerLicensed,
          providerName = payload.providerName,
          receivingReferrals = payload.receivingReferrals,
          offersSpecializedScreening = payload.offersSpecializedScreening,
          service = payload.service,
          status = payload.status;
        if (id && isAlreadySelected(state, id, service)) {
          throw new Error('Attempting to select duplicate program in selectedProgramsReducer');
        }
        return [].concat(_toConsumableArray(state), [{
          id: id,
          isSensitive: isSensitive,
          name: name,
          providerId: providerId,
          providerLicensed: providerLicensed,
          providerName: providerName,
          receivingReferrals: receivingReferrals,
          offersSpecializedScreening: offersSpecializedScreening,
          service: service,
          status: status
        }]);
      }
    case ADD_PROGRAMS:
      {
        validateType(payload, []);
        return uniqueArray([].concat(_toConsumableArray(state), _toConsumableArray(payload)));
      }
    case REMOVE_PROGRAM:
      {
        var _id = payload.id,
          _service = payload.service,
          _name = payload.name;
        var notAlreadySelected = _id ? !isAlreadySelected(state, _id, _service) : !isUnlistedAlreadySelected(state, _name, _service);
        if (notAlreadySelected) {
          throw new Error('Attempting to remove nonexistant selection in selectedProgramsReducer');
        }
        var filterPrograms = function filterPrograms(prog) {
          if (!_id && _name) {
            return !(prog.name === _name && prog.service === _service);
          }
          return !(prog.id === _id && prog.service === _service);
        };
        return _toConsumableArray(state.filter(filterPrograms));
      }
    case REPLACE_PROGRAMS:
      {
        validateType(payload, []);
        return payload;
      }
    case REMOVE_ALL_PROGRAMS:
      {
        return initState;
      }
    default:
      throw new Error("Unrecognized action type: ".concat(type, " in selectedProgramsReducer"));
  }
}
export var useSelectedPrograms = function useSelectedPrograms() {
  var _useSelectedProgramsC = useSelectedProgramsContext(),
    state = _useSelectedProgramsC.state,
    dispatch = _useSelectedProgramsC.dispatch;
  if (state === undefined) {
    throw new Error('must be used within a SelectedProgramsProviderContext');
  }
  return {
    selectedPrograms: state,
    dispatchAddProgram: function dispatchAddProgram(payload) {
      dispatch({
        type: ADD_PROGRAM,
        payload: payload
      });
    },
    dispatchAddPrograms: function dispatchAddPrograms(payload) {
      dispatch({
        type: ADD_PROGRAMS,
        payload: payload
      });
    },
    dispatchRemoveProgram: function dispatchRemoveProgram(payload) {
      dispatch({
        type: REMOVE_PROGRAM,
        payload: payload
      });
    },
    dispatchReplacePrograms: function dispatchReplacePrograms(payload) {
      dispatch({
        type: REPLACE_PROGRAMS,
        payload: payload
      });
    },
    dispatchRemoveAllPrograms: function dispatchRemoveAllPrograms() {
      dispatch({
        type: REMOVE_ALL_PROGRAMS
      });
    }
  };
};
export function SelectedProgramsProvider(_ref2) {
  var children = _ref2.children;
  var _useReducer = useReducer(selectedProgramsReducer, initState),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  if (state === undefined) {
    throw new Error('must be used within a SelectedProgramsProviderContext');
  }
  return /*#__PURE__*/React.createElement(SelectedProgramsProviderContext.Provider, {
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    value: {
      state: state,
      dispatch: dispatch
    }
  }, children);
}
SelectedProgramsProvider.propTypes = {
  children: PropTypes.node.isRequired
};
//# sourceMappingURL=SelectedProgramsContext.js.map